// English (en-GB), homeApp: same shape as homeApp.nl.ts (golf 6b).
export const appHomeEn = {
    customize: 'Customise',
    customizeLabel: 'Customise Today',
    done: 'Done',
    intro: 'Put what matters to you on Today. Drag a card to another spot, make it larger or smaller at its edge or corner, or choose S, M or L.',
    /** Telefoon: alleen de volgorde (feat/vandaag-raster). */
    introList: 'Put the cards in the order you want: drag by the handle or use the arrows. On a larger screen you can also place them freely and make them larger or smaller.',
    undo: 'Undo',
    undone: 'The last change has been undone.',
    /** Raster (computer en tablet): zoals de bord-editor. */
    gridHint: 'Today grid: drag a card to another spot, pull its edge or corner to make it smaller or larger.',
    cardAt: '{name}, {w} by {h} cells, column {x}, row {y}',
    keysHint: 'Arrow keys: move. Shift and arrow keys: smaller or larger.',
    noRoom: "Doesn't fit here. Make something smaller or remove something first.",
    size: 'Size',
    sizes: { S: 'Small', M: 'Medium', L: 'Large' },
    fitMore: '+{count} more',
    fitMoreAll: 'See more',
    reset: 'Restore default',
    resetDone: 'Today is back to how it was.',
    saveFailed: 'Saving did not work. Please try again in a moment.',
    add: 'Add a card',
    addTitle: 'Add a card',
    addNothing: 'All cards are already on it.',
    moveUp: 'Move {name} up',
    moveDown: 'Move {name} down',
    remove: 'Remove {name}',
    removed: '{name} has been removed.',
    added: '{name} is now on Today.',
    drag: 'Drag {name}',
    position: '{name} is now in place {pos} of {count}.',
    empty: 'Today is still empty.',
    emptyBody: 'Tap Customise and choose what you want to see here.',
    emptyEdit: 'No cards yet. Add one below.',
    quiet: 'Nothing to show right now. The card appears by itself when there is something.',
    widgets: {
        now: { name: 'Happening now', description: 'What is on now or starts soon' },
        agenda: { name: 'Today’s calendar', description: 'All of today’s events' },
        tasks: { name: 'Today’s tasks', description: 'How far everyone is with their tasks' },
        tomorrow: { name: 'Tomorrow', description: 'A look at tomorrow’s events' },
        weather: { name: 'Weather', description: 'Weather and what to wear, tap for more' },
        rides: { name: 'Rides', description: 'Rides nobody is driving yet' },
        prayer: { name: 'Prayer times', description: 'Today’s times' },
        check_in: { name: 'Daily check-in', description: "Whether today's 'All good' came in" },
        goals: { name: 'Saving up', description: 'How far the children are with saving' },
        shopping: { name: 'Shopping', description: 'What still needs to be bought' },
        messages: { name: 'Messages', description: 'New messages from the family' },
        wishes: { name: 'Wishes', description: 'The children’s wishes' },
        rotation: { name: 'Rota', description: 'Who does what this week and who cooks today' },
        // Golf 8 (0049): Samen wonen.
        dinner: { name: 'Dinner tonight', description: "Who's in and your choice" },
        bookings: { name: 'Bookings', description: 'Your next booking and what is free' },
        balance: { name: 'Costs', description: 'Only your own balance' },
        // 0069: Geldzaken (alleen in je eigen omgeving).
        money: { name: 'Money', description: 'What was left this month (only you)' },
        todos: { name: 'To-dos', description: 'Your open to-dos, with a done-by date' },
        // 0076: schoolplanner.
        school: {
            name: 'Homework and tests',
            description: 'Today’s homework, upcoming tests and grades to enter',
        },
        // 0075: Huisronde (module Eten).
        house_round: { name: 'House round', description: 'The next round of the house, and start it' },
    },
    shopping: {
        open: { one: '{count} thing to buy', other: '{count} things to buy' },
        empty: 'Everything has been bought.',
        all: 'Go to shopping',
        more: '+{count} more',
    },
    messages: {
        unread: { one: '{count} new message', other: '{count} new messages' },
        none: 'No new messages.',
        all: 'Go to messages',
        voice: 'Voice message',
        sticker: 'Sticker',
        pictos: 'Pictures',
    },
    wishes: {
        count: { one: '{count} wish', other: '{count} wishes' },
        empty: 'No wishes yet.',
        all: 'Go to wishes',
    },
    /** Golf 6b fixer r1: widget Beurtrooster (huisgenoten). */
    rotation: {
        you: 'You this week',
        done: 'Done',
        open: 'Still to do',
        noneForYou: 'You have no turn this week.',
        cooks: '{name} cooks today',
        youCook: 'You cook today',
        others: 'The rest of the house',
        all: 'Go to the rota',
        empty: 'No rota yet.',
    },
    prayer: {
        next: 'Next',
        settings: 'Settings',
        fromTable: 'From your mosque’s timetable',
    },
};
export const appAgendaViewsEn = {
    day: 'Day',
    workweek: 'Work week',
    week: 'Week',
    month: 'Month',
    workweekTitle: 'Work week {week} · {range}',
    emptyWorkweek: 'Nothing planned this work week yet',
    prev: {
        day: 'Previous day',
        workweek: 'Previous work week',
        week: 'Previous week',
        month: 'Previous month',
    },
    next: { day: 'Next day', workweek: 'Next work week', week: 'Next week', month: 'Next month' },
    keys: 'Shortcuts: ← and → to browse, T for today.',
};
export const appWeatherDetailEn = {
    open: 'More about the weather',
    titleToday: 'The weather today',
    titleTomorrow: 'The weather tomorrow',
    today: 'Today',
    tomorrow: 'Tomorrow',
    temp: 'Temperature',
    tempRange: '{min}° to {max}°',
    feels: 'Feels like',
    feelsRange: '{min}° to {max}°',
    feelsDay: 'around {value}° during the day',
    rain: 'Rain',
    rainChance: {
        dry: 'Dry',
        small: 'Small chance of a shower',
        likely: 'Chance of rain',
        wet: 'Rainy',
    },
    rainAmount: '{mm} mm',
    rainHours: { one: 'in {count} hour', other: 'in {count} hours' },
    rainWhen: 'between {from} and {until}',
    rainPct: '{pct}% chance',
    rainNoPct: 'For the Netherlands MET Norway gives no chance in per cent. This is how much rain the forecast expects.',
    wind: 'Wind',
    windForce: 'Force {bft}',
    windFrom: 'from the {dir}',
    windSpeed: '{kmh} km/h',
    bft: [
        'calm',
        'light air',
        'light breeze',
        'gentle breeze',
        'moderate breeze',
        'fresh breeze',
        'strong breeze',
        'near gale',
        'gale',
        'strong gale',
        'storm',
        'violent storm',
        'hurricane',
    ],
    dirs: {
        N: 'north',
        NE: 'north-east',
        E: 'east',
        SE: 'south-east',
        S: 'south',
        SW: 'south-west',
        W: 'west',
        NW: 'north-west',
    },
    dirShort: { N: 'N', NE: 'NE', E: 'E', SE: 'SE', S: 'S', SW: 'SW', W: 'W', NW: 'NW' },
    uv: 'UV index',
    uvLevels: {
        low: 'low',
        moderate: 'moderate',
        high: 'high',
        very_high: 'very high',
        extreme: 'extreme',
    },
    uvValue: 'UV {value}, {level}',
    uvClearSky: 'with a clear sky',
    sun: 'Sun',
    sunrise: 'Rises {time}',
    sunset: 'Sets {time}',
    course: 'Through the day',
    courseOpen: 'Hour by hour',
    back: 'Back',
    courseTemp: 'Temperature (°C)',
    courseRain: 'Rain (mm per hour)',
    courseHour: '{time}: {temp}°, {rain} mm, force {bft}',
    partial: 'Not all hours of this day are known yet.',
    now: 'Now',
    close: 'Close',
    symbols: {
        clear: 'sunny',
        partly_cloudy: 'partly cloudy',
        cloudy: 'cloudy',
        fog: 'fog',
        drizzle: 'drizzle',
        rain: 'rain',
        heavy_rain: 'heavy rain',
        sleet: 'sleet',
        snow: 'snow',
        thunder: 'thunder',
    },
};
//# sourceMappingURL=homeApp.en.js.map